import './nicolej/style';
import FormStructure from './nicolej/form_structure';

export default FormStructure;